module.exports = __webpack_public_path__ + "static/img/energy-h5-4.512b9ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/energy-h5-4.png
// module id = CZvq
// module chunks = 34